import OptionsAction from 'reducers/Options'
import { ReleasesService } from 'services'
import { LOADING_STATES } from 'constants/enums'
import type { AppDispatch } from 'types/store'

export const getOptions = () => (dispatch: AppDispatch) => {
  dispatch(OptionsAction.loading(LOADING_STATES.LOADING))

  ReleasesService.getOptions()
    .then((response: any) => {
      dispatch(OptionsAction.setOptions(response.data))
      dispatch(OptionsAction.loading(LOADING_STATES.SUCCESS))
    })
    .catch((error: any) => {
      console.error(error)
      dispatch(OptionsAction.loading(LOADING_STATES.ERROR))
    })
}

export default {
  getOptions,
}
